import axios, { resHandle } from "@/plugins/axios";


/**
 * @description 获取数据中心信息
 * @param vCom Vue组件
 */
const GetCenterInfo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/info", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取患者列表
 * @param vCom Vue组件
 * @param params 参数
 */
const GetPatientsList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/yjdl/patients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获得分中心列表
 * @param vCom Vue组件
 */
const GetHospitals = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/user/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 添加患者
 * @param vCom Vue组件
 */
const CreatePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获得左侧列表
 * @param vCom Vue组件
 */
const GetLeftNav = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/yjdl/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 个人信息详情
 * @param vCom Vue组件
 */
const GetPatientInfo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 模板详情
 * @param vCom Vue组件
 */
const GetTemplates = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/template", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 数据详情
 * @param vCom Vue组件
 */
const GetContents = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/contents", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 修改患者
 * @param vCom Vue组件
 */
const PutUpdatePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.put("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取创建Oss的初始参数
 * @param vCom Vue组件
 */
const GetOssParams = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                type: "file"
            }
        };
        axios.get("api/oss", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 名中医传承数据中心数据导出
 * @param vCom Vue组件
 */
const PostDataExport = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/export/lincenter", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 数据导出：模板列表（导出页面右边的接口）
 * @param vCom Vue组件
 */
const GetDataExportTemplates = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/data/table/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 【副本】患者做过的影像测评列表
 * @param vCom Vue组件
 */
const GetDetailLeftNavDoneList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/image/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 【副本】患者做过的治未病体质测评列表
 * @param vCom Vue组件
 */
const GetDetailLeftNavDoneListZwb = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/zwb/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 专病集合列表[访视列表]
 * @param vCom Vue组件
 */
const GetZhuanbingJiheLiebiao = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/center/interviews", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取患者某部分信息
 * @param vCom Vue组件
 */
const GetZwbPartDetail = (vCom: any, patientId: string, part: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                patient_id: patientId
            }
        };
        const requestUrl: any = {
            中医体质辨识: "api/zwb/patient/nines",
            四诊合参体质辨识: "api/zwb/patient/tcms",
            儿童体质辨识: "api/zwb/patient/chds",
            老年人体质辨识: "api/zwb/patient/olds",
            备孕女性健康状态测评: "api/zwb/patient/prepres",
            孕期女性健康状态测评: "api/zwb/patient/pres",
            产后女性健康状态测评: "api/zwb/patient/partums",
            围绝经期女性健康状态测评: "api/zwb/patient/wjjqs",
            高血压病辅助辨证: "api/zwb/patient/hyps",
            糖尿病辅助辨证: "api/zwb/patient/dias",
            中医心理测评: "api/zwb/patient/phys"
        };
        axios.get(requestUrl[part], params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};





export {
    GetPatientsList, GetHospitals, CreatePatient, GetLeftNav, GetPatientInfo, PutUpdatePatient,
    GetTemplates, GetContents, GetOssParams, PostDataExport, GetDataExportTemplates,
    GetDetailLeftNavDoneList, GetCenterInfo, GetZhuanbingJiheLiebiao, GetDetailLeftNavDoneListZwb,
    GetZwbPartDetail
};
